var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendationCompletion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 124",
    style: {
      enableBackground: "new 0 0 120 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ray"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.16,52.45c-0.6-1.16-1.8-1.9-3.11-1.9H69.52V8.5c0-1.53-0.99-2.88-2.44-3.34c-1.46-0.46-3.04,0.07-3.92,1.31 L21.09,66.06c-0.76,1.07-0.85,2.47-0.25,3.64c0.6,1.17,1.8,1.89,3.11,1.89h24.54v42.05c0,1.53,0.99,2.88,2.44,3.34 c0.35,0.11,0.71,0.17,1.06,0.17c1.12,0,2.19-0.54,2.86-1.48l42.06-59.58C97.66,55.01,97.76,53.61,97.16,52.45z M55.5,102.6V68.08 c0-1.93-1.57-3.5-3.51-3.5H30.72l31.79-45.04v34.52c0,1.94,1.57,3.51,3.51,3.51h21.27L55.5,102.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationCompletion);
export default __webpack_public_path__ + "static/media/recommendationCompletion.6901db64ae8e1dac55b125adc3619cd6.svg";
export { ForwardRef as ReactComponent };